import React, { memo } from 'react';
import { Zap, Layers, Code, BarChart } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    title: 'Idea-to-App Package',
    description: 'Complete transformation of your concept into a market-ready application with ongoing support.',
    icon: <Zap className="w-6 h-6 text-[#00E5FF]" data-id="element-162" />,
    gradient: 'from-[#00E5FF] to-[#00E5FF]/50'
  }, {
    title: 'UI/UX Design',
    description: 'Intuitive, engaging interfaces that create emotional connections and memorable experiences.',
    icon: <Layers className="w-6 h-6 text-[#B721FF]" data-id="element-163" />,
    gradient: 'from-[#B721FF] to-[#B721FF]/50'
  }, {
    title: 'Full-Stack Development',
    description: 'Robust, scalable app development using cutting-edge technologies and future-proof architecture.',
    icon: <Code className="w-6 h-6 text-[#00E5FF]" data-id="element-164" />,
    gradient: 'from-[#00E5FF] to-[#00E5FF]/50'
  }, {
    title: 'App Marketing & Management',
    description: 'Strategic launch and growth services to build your user base and establish market presence.',
    icon: <BarChart className="w-6 h-6 text-[#B721FF]" data-id="element-165" />,
    gradient: 'from-[#B721FF] to-[#B721FF]/50'
  }];
  return <section id="services" className="relative py-20 w-full overflow-hidden" data-id="element-166">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[#0B0C10] z-0" data-id="element-167">
        <div className="absolute inset-0 flex flex-wrap gap-4 opacity-10" data-id="element-168">
          {Array.from({
          length: 20
        }).map((_, i) => <div key={i} className="w-24 h-24 border border-[#F5F5F5]/5 rounded-lg" data-id="element-169"></div>)}
        </div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-bold font-['Orbitron'] mb-4" data-id="element-172">
            Our{' '}
            <span className="bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-173">
              Services
            </span>
          </h2>
          <p className="text-lg text-[#F5F5F5]/70 max-w-2xl mx-auto" data-id="element-174">
            Comprehensive solutions tailored to transform your vision into
            digital reality.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-175">
          {services.map((service, index) => <div key={index} className="bg-[#0B0C10]/80 backdrop-blur-sm border border-[#F5F5F5]/10 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#00E5FF]/30 group" data-id="element-176">
              <div className="h-2 bg-gradient-to-r from-[#00E5FF] to-[#B721FF]" data-id="element-177"></div>
              <div className="p-6" data-id="element-178">
                <div className="flex items-start gap-4" data-id="element-179">
                  <div className={`p-3 rounded-lg bg-gradient-to-br ${service.gradient} bg-opacity-10`} data-id="element-180">
                    {service.icon}
                  </div>
                  <div data-id="element-181">
                    <h3 className="text-xl font-bold font-['Orbitron'] mb-2" data-id="element-182">
                      {service.title}
                    </h3>
                    <p className="text-[#F5F5F5]/70" data-id="element-183">{service.description}</p>
                  </div>
                </div>
                <div className="mt-6 flex justify-end" data-id="element-184">
                  <button className="text-sm text-[#00E5FF] hover:text-[#B721FF] transition-colors flex items-center gap-1" data-id="element-185">
                    Learn more
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-186">
                      <path d="M5 12h14" data-id="element-187"></path>
                      <path d="m12 5 7 7-7 7" data-id="element-188"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>)}
        </div>
        {/* App mockup */}
        <div className="mt-16 flex justify-center" data-id="element-189">
          <div className="relative" data-id="element-190">
            <div className="bg-[#0B0C10] border border-[#F5F5F5]/10 rounded-[32px] p-2 shadow-xl shadow-[#00E5FF]/5 max-w-[300px]" data-id="element-191">
              <div className="rounded-[24px] overflow-hidden" data-id="element-192">
                <img src="https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=1974&auto=format&fit=crop" alt="App interface mockup" className="w-full h-[600px] object-cover" data-id="element-193" />
              </div>
              <div className="mt-2 flex justify-center" data-id="element-194">
                <div className="w-32 h-1 bg-[#F5F5F5]/20 rounded-full" data-id="element-195"></div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gradient-to-r from-[#00E5FF] to-[#B721FF] rounded-full blur-[32px] opacity-50" data-id="element-196"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-gradient-to-r from-[#B721FF] to-[#00E5FF] rounded-full blur-[32px] opacity-50" data-id="element-197"></div>
          </div>
        </div>
      </div>
    </section>;
};